import React from 'react'

const Banner = ({img,text}) => {
    return (
        <section className="banner-section">
            <div className="wrapper">
                <img src={img}
                    alt="" />
                <div className="overlay"></div>
                <h1>{text}</h1>
            </div>
        </section>
    )
}

export default Banner